import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

//Common
import { fn_formatarDataHora } from "@/common/utils/date";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones";

/*
 * Histórico da posse do pagamento: a data/hora e o usuário de cada vez que a posse foi salva, em ordem crescente.
 * @logs: log de alteração da data da posse do pagamento (api_listarHistoricoPosse), carregado pela tela que chama
 *        (o botão que abre o histórico só aparece quando existe registro)
 */
function TPag_historico_posse({ modalOpen, toggleModal, logs }) {
  return (
    <Modal isOpen={modalOpen} backdrop="static" size="lg" scrollable>
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        Histórico Posse Documento
      </ModalHeader>

      <ModalBody>
        <div className="m-1">
          <Table responsive>
            <thead>
              <tr>
                <td width="30%" className="table-header">
                  Data/hora
                </td>
                <td className="table-header">Usuário</td>
              </tr>
            </thead>

            <tbody>
              {logs.map((log, index) => (
                <tr key={index}>
                  <td>{fn_formatarDataHora(log.data)}</td>
                  <td>{log.usuario?.nome}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button name="btnFechar" color="secondary" onClick={toggleModal}>
          {ICONES_BOTAO.FECHAR} Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default TPag_historico_posse;
